import React from 'react';
import { DiscountType } from '../../types/Voucher';
import { Currency } from '@flixbus/honeycomb-react';

// Define the props
interface CreditBalanceProps {
  discountType: DiscountType;
}

const CreditBalance: React.FC<CreditBalanceProps> = ({ discountType }) => {
  if ('credit' in discountType) {
    return (
      <>
        <Currency value={discountType.credit.amount} code={discountType.credit.currency} />
      </>
    );
  }

  return <></>;
};

export default CreditBalance;
